import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bid-phases__row" }
const _hoisted_2 = { class: "bid-phases__phase-title" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "bid-phases__row" }
const _hoisted_5 = { class: "bid-phases__row bid-phases__total text-right" }


import { reactive, computed, onMounted, watch } from 'vue';
import { Utils } from '@/utils';
import { IAsset } from '@/types/store';
import { IPhase } from '@/types/phases';
import { useStore } from 'vuex';
import AppBidInput from '@/components/App/AppBidInput.vue';

// #interfaces
interface IProps {
  isDisabledForm: boolean;
}

// #props

export default /*@__PURE__*/_defineComponent({
  __name: 'BidViewPhases',
  props: {
    isDisabledForm: { type: Boolean, default: false }
  },
  setup(__props: any) {



// #constants
const { getters, dispatch } = useStore();

// #data
const deserts = reactive<IPhase[]>([]);

// #computed
const getAsset = computed<IAsset>(() => {
  return getters['getAsset'];
});
const getPhaseValues = computed<(string | number)[]>(() => {
  return getters['getPhaseValues'];
});
const totalSum = computed<string | number>(() => {
  const unParsedPrice = (deserts || [])
    .map((phase) => {
      return phase.value;
    })
    .reduce((a, b) => {
      return (+a || 0) + (+b || 0);
    }, 0);
  return Utils.formatPrice(unParsedPrice);
});
const getCurrency = computed<string>(() => {
  const { currency = '' } = getAsset.value ?? {};
  if (currency === 'USD') {
    return '$';
  }
  return currency;
});

// #methods
const onSetPhases = () => {
  const { phases = [] } = getAsset.value ?? {};

  (phases as IPhase[]).forEach((phase: IPhase, index: number) => {
    deserts.push({
      ...phase,
      value: Number(getPhaseValues.value[index])
    });
  });
};

// #wathers
watch(deserts, () => {
  dispatch('setPhasesValues', deserts);
});

// #hooks
onMounted(() => {
  onSetPhases();
});

return (_ctx: any,_cache: any) => {
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createBlock(_component_v_table, {
    "fixed-header": "",
    class: "bid-phases"
  }, {
    default: _withCtx(() => [
      _cache[2] || (_cache[2] = _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", { class: "text-left bid-phases__heading" }, "Phase"),
          _createElementVNode("th", { class: "text-left bid-phases__heading" }, "Price")
        ])
      ], -1)),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(deserts, (item) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: item.title,
            class: "bid-phases__tr"
          }, [
            _createElementVNode("td", _hoisted_1, [
              _createElementVNode("span", _hoisted_2, _toDisplayString(item.title), 1),
              _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("span", {
                class: "bid-phases__phase-description",
                innerHTML: item.description
              }, null, 8, _hoisted_3)
            ]),
            _createElementVNode("td", _hoisted_4, [
              _createVNode(AppBidInput, {
                disabled: __props.isDisabledForm,
                class: "bid-phases__phase-input",
                prefix: getCurrency.value,
                "model-value": item.value,
                "onInput:modelValue": ($event: any) => (item.value = $event)
              }, null, 8, ["disabled", "prefix", "model-value", "onInput:modelValue"])
            ])
          ]))
        }), 128)),
        _createElementVNode("tr", null, [
          _cache[1] || (_cache[1] = _createElementVNode("td", { class: "bid-phases__row bid-phases__total" }, "Total Bid", -1)),
          _createElementVNode("td", _hoisted_5, _toDisplayString(getCurrency.value) + " " + _toDisplayString(totalSum.value), 1)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})